import { getMetaValueRaw } from '@rad/utility/meta';
import APPSETTINGS from '@appsettings';
import { mkPath, mkUrl } from './_';
export const onSubdomain = !!getMetaValueRaw('76U-DISTRICT-ID');
export const generalUrls = {
    notFound: mkUrl(['404']),
    login: mkUrl(mkPath('login')),
    signUp: mkUrl(mkPath('signup')),
    invite: mkUrl(mkPath('invite')),
    tourInvite: mkUrl(mkPath('tour-invite', '$token')),
    unsubscribe: mkUrl(['unsubscribe']),
};
export const accountUrls = {
    accountDefault: mkUrl(mkPath('account')),
    account: mkUrl(mkPath('account', '$tab')),
    myPropertiesManage: mkUrl(mkPath('account', 'my-properties', 'manage', '$id')),
    myProperty: mkUrl(mkPath('account', 'my-properties', '$id')),
};
export const landingUrls = {
    root: mkUrl(mkPath()),
    policy: mkUrl(mkPath('policy', '$kind')),
    // The root of every tour's link. The server answers /tours/<key> itself and only lets a link it
    // cannot find reach the app.
    tours: mkUrl(mkPath('tours')),
    tourNotFound: mkUrl(mkPath('tours', '$key')),
};
export const exploreUrls = {
    explore: mkUrl(mkPath('explore')),
};
export const paymentUrls = APPSETTINGS.PAYMENTS_ENABLED ? {
    pricing: mkUrl(mkPath('pricing')),
    proCheckout: mkUrl(mkPath('pricing', 'pro')),
} : null;
export const propertyUrls = {
    property: mkUrl(mkPath('properties', '$id')),
    parcel: mkUrl(mkPath('parcels', '$id')),
    // Address and point ride in the query string -- there is no parcel to key on yet.
    address: mkUrl(mkPath('address')),
};
// An organization's named view at its permanent address
export const orgUrls = {
    story: mkUrl(mkPath('org', '$org', 'story', '$id')),
};
